import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getOfferData, getOfferList } from "./OfferApi";
import { OfferDataState } from "../../../features/view/public/offerListing/offerListingTypes";

const initialState: OfferDataState = {
  offerList: { data: [], loader: false },
  offerData: { data: {}, loader: false },
};

export const getOfferListAsync = createAsyncThunk(
  "/orders/discounts/",
  async (payload?: any) => {
    const response = await getOfferList(payload);
    return response;
  }
);

export const getOfferDataAsync = createAsyncThunk(
  "orders/discounts",
  async (id: any) => {
    const response = await getOfferData(id);
    return response;
  }
);

export const OfferSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getOfferListAsync.pending, (state) => {
        state.offerList.loader = true;
      })
      .addCase(getOfferListAsync.fulfilled, (state, action: any) => {
        state.offerList.loader = false;
        state.offerList.data = action?.payload?.data || [];
      })
      .addCase(getOfferListAsync.rejected, (state) => {
        state.offerList.loader = false;
      })
      .addCase(getOfferDataAsync.pending, (state) => {
        state.offerData.loader = true;
      })
      .addCase(getOfferDataAsync.fulfilled, (state: any, action: any) => {
        const data = action?.payload?.data?.products || [];

        const filteredProducts = data.filter((product: any) => {
          return product?.skus?.some(
            (sku: { sku_status: string }) => sku?.sku_status === "Visible"
          );
        });
        state.offerData.data = {
          ...action.payload.data,
          products: filteredProducts,
        };
        state.offerData.loader = false;
      })
      .addCase(getOfferDataAsync.rejected, (state: any) => {
        state.offerData.loader = false;
      });
  },
});

export default OfferSlice.reducer;
